(() => {
  const dialog = document.getElementById('xh-navigation-dialog');
  const toggle = document.querySelector('[data-xh-menu-open]');
  if (!dialog || !toggle) return;
  let timer;
  function closeMenu() {
    if (!dialog.open || dialog.classList.contains('xh-closing')) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { dialog.close(); return; }
    dialog.classList.add('xh-closing');
    timer = window.setTimeout(() => dialog.close(), 180);
  }
  toggle.addEventListener('click', () => {
    document.querySelectorAll('dialog[open]').forEach(item => item.close());
    dialog.classList.remove('xh-closing');
    dialog.showModal();
    toggle.setAttribute('aria-expanded', 'true');
  });
  dialog.querySelector('[data-xh-menu-close]').addEventListener('click', closeMenu);
  dialog.addEventListener('cancel', event => { event.preventDefault(); closeMenu(); });
  dialog.addEventListener('click', event => { if (event.target === dialog || event.target.closest('a')) closeMenu(); });
  dialog.addEventListener('close', () => {
    window.clearTimeout(timer);
    dialog.classList.remove('xh-closing');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.focus();
  });

})();
